/* eslint-disable  jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */

import ButtonBase from '@material-ui/core/ButtonBase'
import IconButton from '@material-ui/core/IconButton'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    '&$wrapper + div': {
      marginTop: 16,
    },
  },
  buttonWrap: {
    width: '100%',
  },
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    margin: 0,
    padding: '16px 8px 16px 16px',
    border: props => (props.checked ? theme.borders.borderActive : theme.borders.default),
    borderRadius: theme.borders.borderRadius,
    color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`,
    fontSize: theme.typography.fontSizeBase,
    fontFamily: theme.typography.defaultFont,
    '-webkit-font-smoothing': 'antialiased',
    fontSmooth: 'antialiased',
    '&:hover, &:focus': {
      cursor: 'pointer',
      border: theme.borders.borderActive,
    },
    '&[disabled]:hover': {
      borderColor: `var(--gameday-borders-borderColor, ${theme.borders.borderColor})`,
      cursor: 'not-allowed',
    },
    '&[disabled]': {
      color: `var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`,
    },
    '& td:empty': {
      display: 'none',
    },
    '& td': {
      padding: 0,
    },
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& img': {
      float: 'left',
      maxHeight: 40,
      display: 'block',
      '& + img': {
        marginLeft: 8,
      },
    },
  },
  label: {
    padding: '0 16px',
  },
  description: {
    padding: '0 16px',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    fontSize: theme.typography.fontSizeTinyish,
  },
  small: {
    padding: '8px 8px 8px 16px',
    '& img': {
      maxHeight: 26,
    },
  },
  radio: {},
  logoWrap: {},
  actionButton: {
    margin: '0 6px',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  contentWrapper: {
    display: 'flex',
    width: '100%',
  },
})

const RadioAdvanced = ({
  hidden,
  actionIcon,
  children,
  classes,
  className,
  description,
  disabled,
  label,
  name,
  onClickAction,
  size,
  value,
  logoFullWidth,
  postFix,
  content,
  ...rest
}) => {
  if (hidden) {
    return
  }

  return (
    <div className={classes.wrapper}>
      <ButtonBase classes={{ root: classes.buttonWrap }}>
        {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
        <label
          htmlFor={value}
          className={cn(classes.root, classes[size], className)}
          disabled={disabled}
          onClick={e => e.preventDefault}
        >
          <div className={classes.contentWrapper}>
            <div className={classes.details}>
              {children ? (
                <div className={classes.logoWrap} style={{ width: logoFullWidth ? '100%' : 110 }}>
                  {children}
                </div>
              ) : null}
              {label ? <span className={classes.label}>{label}</span> : null}
              {description ? <span className={classes.description}>{description}</span> : null}
              {postFix && <>{postFix}</>}
            </div>
            <Radio
              color="primary"
              classes={{ root: classes.radio }}
              disabled={disabled}
              id={value}
              name={name}
              value={value}
              {...rest}
            />
          </div>
          {content && content}
        </label>
      </ButtonBase>
      {onClickAction ? (
        // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
        <IconButton classes={{ root: classes.actionButton }} onClick={(event, value) => onClickAction(value)}>
          {actionIcon}
        </IconButton>
      ) : null}
    </div>
  )
}

RadioAdvanced.defaultProps = {
  name: 'radio',
  size: 'small',
}

const RadioAdvComponent = withStyles(styles)(RadioAdvanced)
RadioAdvComponent.displayName = 'RadioAdvanced'
export default RadioAdvComponent
